import React, {useRef, useState} from "react";

import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import Recaptcha from "react-google-recaptcha";
import {css} from "@emotion/css";
import {RouteInfo} from "../../../route/RouteHelper";
import {useLocation, useNavigate} from "react-router-dom";
import {LoginService} from "../../../connection-services/login/LoginService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {Helmet} from "react-helmet";
import {
    RaikoButtonPrimary,
    RaikoNumberInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

const SignInForgetPassword = () => {

    const {state} = useLocation()

    const service = new LoginService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [phoneNumber, setPhoneNumber] = useState(state && state.phoneNumber ? state.phoneNumber : "")

    const reCaptchaRef = useRef(undefined);
    const [recaptchaGeneratedKey, setRecaptchaGeneratedKey] = useState(null);

    const navigate = useNavigate()

    const handleGenerateRecaptcha = () => {
        return new Promise(async (resolve, reject) => {

            if (recaptchaGeneratedKey) {
                setRecaptchaGeneratedKey(null)
                window.grecaptcha.reset();
            }

            let newVar = await reCaptchaRef.current.executeAsync();

            resolve(newVar)
        })
    }

    function sendOtpSms() {
        if (phoneNumber.length === 11) {
            handleGenerateRecaptcha()
                .then(key => {
                    loading.show()
                    service.sendOtpSmsForgetPassword(phoneNumber, key)
                        .then(response => {
                            showSuccessMessage("کد تایید با موفقیت ارسال شد.")
                            navigate(RouteInfo.SignInRefreshPassword.globalUrl, {state: {phoneNumber}})
                        }).catch(reason => {
                        showErrorMessage(detectServerErrorMessage(reason))
                    }).finally(_ => {
                        loading.hide()
                    })
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            })
        } else {
            showWarningMessage("لطفا شماره ی همراه خود را به درستی وارد نمایید.")
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.SignInForgetPassword.name}</title>
            </Helmet>
            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>فراموشی رمز عبور</span>
                </div>
                <form className={"signInContentContainer"}>
                    <span className={"subTitle"}>لطفا شماره ی همراه خود را وارد نمایید.</span>
                    <RaikoNumberInputOutlined
                        labelText={"شماره همراه"}
                        setValue={value => {
                            if (value.length < 12) {
                                setPhoneNumber(value)
                            }
                        }}
                        value={phoneNumber}
                    />

                    <Recaptcha
                        ref={reCaptchaRef}
                        className={'g-recaptcha'}
                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                        render={"explicit"}
                        size={"invisible"}
                        onChange={setRecaptchaGeneratedKey}
                        hl={"fa"}
                    />

                    <RaikoButtonPrimary
                        label={"تایید"}
                        className={css`width: 100%`}
                        onClick={sendOtpSms}/>

                    <span className={"forgetPassword"} onClick={_ => {
                        navigate(RouteInfo.SignInEnterPhoneNumber.globalUrl, {replace: true})
                    }}>
                    ورود به سامانه
                </span>
                </form>
            </div>
        </>
    )
}


export default SignInForgetPassword;